// event.ts
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { saveAs } from 'file-saver';

dayjs.extend(utc);

function escapeICSText(input: string) {
    return input.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
}

function foldICSLines(ics: string) {
    const lines = ics.split('\r\n');
    const folded: string[] = [];
    for (const line of lines) {
        if (line.length <= 75) {
            folded.push(line);
        } else {
            let start = 0;
            while (start < line.length) {
                const chunk = line.slice(start, start === 0 ? 75 : start + 74);
                folded.push(start === 0 ? chunk : ' ' + chunk);
                start += start === 0 ? 75 : 74;
            }
        }
    }
    return folded.join('\r\n');
}

function formatUtc(dt: dayjs.Dayjs) {
    return dt.utc().format('YYYYMMDD[T]HHmmss[Z]');
}

export const downloadCalendar = () => {
    const todaysDate = dayjs();
    const startdate = todaysDate.add(182, 'day');

    const startLocal = startdate.hour(9).minute(0).second(0).millisecond(0);
    const endLocal = startLocal.add(15, 'minute');

    const dtstamp = formatUtc(dayjs());
    const dtstart = formatUtc(startLocal);
    const dtend = formatUtc(endLocal);

    const title = 'Mid-life MOT Reminder';
    const description =
        `This is a reminder for you to retake the Mid-life MOT in 6 months time ` +
        `you can retake it here - ${import.meta.env.VITE_DOMAIN_NAME}`;
    const location = 'Online';

    const uid =
        typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `${Date.now()}@midlife-mot`;

    let ics =
        'BEGIN:VCALENDAR\r\n' +
        'VERSION:2.0\r\n' +
        'PRODID:-//Midlife MOT//EN\r\n' +
        'CALSCALE:GREGORIAN\r\n' +
        'METHOD:PUBLISH\r\n' +
        'BEGIN:VEVENT\r\n' +
        `UID:${uid}\r\n` +
        `DTSTAMP:${dtstamp}\r\n` +
        `DTSTART:${dtstart}\r\n` +
        `DTEND:${dtend}\r\n` +
        `SUMMARY:${escapeICSText(title)}\r\n` +
        `DESCRIPTION:${escapeICSText(description)}\r\n` +
        `LOCATION:${escapeICSText(location)}\r\n` +
        'BEGIN:VALARM\r\n' +
        'TRIGGER:-PT15M\r\n' +
        'ACTION:DISPLAY\r\n' +
        'DESCRIPTION:Reminder\r\n' +
        'END:VALARM\r\n' +
        'END:VEVENT\r\n' +
        'END:VCALENDAR\r\n';

    ics = foldICSLines(ics);

    const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    saveAs(blob, 'reminderMOT.ics');
};
